import { isSweepstakesQuery } from '@gig/magic-common';
import { __awaiter, __generator } from 'tslib';
import { AmlStatus } from '@gig/magic-sdk/dist/adapter/users/getAmlStatus';
import { documentType, getCategoryByDocumentType } from './document-type.config.js';
import { documentNumber } from './document-number.config.js';
import { documentExpiryDate } from './document-expiry-date.config.js';
import { documentSide } from './document-side.config.js';

function getUploadFormConfig(type, files, allowAllDocumentsUpload) {
    return __awaiter(this, void 0, void 0, function () {
        var category, categoryFiles, isSweepstakes;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    category = getCategoryByDocumentType(type);
                    if (!allowAllDocumentsUpload) {
                        categoryFiles = files.filter(function (file) {
                            return file.category === category &&
                                file.verificationStatus === AmlStatus.REQUESTED;
                        });
                        if (categoryFiles.length === 0) {
                            return [2 /*return*/, []];
                        }
                    }
                    return [4 /*yield*/, isSweepstakesQuery()];
                case 1:
                    isSweepstakes = _a.sent();
                    return [2 /*return*/, [
                            {
                                name: 'step-1',
                                path: 'step-1',
                                components: [
                                    documentType(type, files),
                                    documentNumber(),
                                    documentExpiryDate({
                                        reverseMonth: isSweepstakes,
                                    }),
                                    documentSide(),
                                ],
                            },
                        ]];
            }
        });
    });
}

export { getUploadFormConfig };
